<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Add Bank</h3>
        <b-form role="form" @submit.prevent="addBank">
            <b-row>
                <b-col cols="6">
                    <b-form-group label="Bank">
                        <el-select v-model="form.bank_code" filterable placeholder="Select" @change="getBankerListHandler" v-loading="is_loading_bank" >
                            <el-option
                            v-for="bank in banks"
                            :key="bank.bank_code"
                            :label="bank.bank_name"
                            :value="bank.bank_code"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Banker">
                        <el-select v-model="form.banker_id" filterable placeholder="Select Banker" v-loading="is_loading_bank" no-data-text="Banker Not Available">
                            <el-option
                            v-for="banker in bankers"
                            :key="banker.id"
                            :label="banker.name"
                            :value="banker.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Loan Officer">
                        <el-select v-model="form.prod_loan_officer_id" clearable filterable placeholder="Select Loan Officer" disabled>
                            <el-option
                            v-for="loan_officer in userLoanOfficerList"
                            :key="loan_officer.id"
                            :label="loan_officer.name"
                            :value="loan_officer.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Loan Amount">
                        <b-form-input
                        v-model="form.loan_amount"
                        type="text"
                        step="0.01"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Interest (%)">
                        <b-form-input
                        v-model="form.interest"
                        type="number"
                        step="0.01"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Tenure Year">
                        <el-select v-model="form.tenure_years" placeholder="Select" >
                            <el-option
                                v-for="num in 10"
                                :key="num"
                                :label="num + ' Years'"
                                :value="num"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Installment">
                        <b-form-input
                        v-model="form.installment"
                        type="number"
                        required
                        step="0.01"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6" >
                    <b-form-group label="Additional Cost">
                        <b-form-input
                        v-model="form.prod_bnk_add_cost"
                        type="number"
                        step="0.01"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                        <h3 class="mb-4">Arrangement Fee</h3>
                    </b-col>

                    <b-col cols="12">
                    <b-form-group label="Arrangement Fee Amount">
                        <b-form-input
                        v-model="form.arrangement_fee"
                        type="number"
                        step="0.01"
                            ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Arrangement Fee SST">
                        <b-form-radio-group
                            v-model="form.arrangement_fee_sst"
                            :options="SST_OPTIONS"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                        <b-form-group label="Total Arrangement Fee (RM)">
                        <b-form-input
                        v-model="form.arrangement_fee_amount"
                        type="text"
                        required
                        disabled
                        placeholder="0.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Bank Submission Date">
                        <b-form-input
                        v-model="form.prod_bnk_submission_date"
                        type="date"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Status">
                        <el-select v-model="form.bank_status" filterable placeholder="Select" :disabled="!checkAccess(['p_product__manage'])">
                            <el-option
                            v-for="(status, index) in status"
                            :key="index"
                            :label="status.status"
                            :value="status.status"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="isApprovedBank">
                    <b-form-group label="Approved Date">
                            <b-form-input
                            v-model="form.approved_date"
                            type="date"
                            required
                            ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_btn">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateInstallment, 
  calculateLoanAmount,
  calculatePersonalLoanInstallment
} from '@/assets/js/calculator.js'
import { useAuthStore } from '@/stores/authStore'
import {BANK_CANNOT_EDIT_STATUS, BANK_APPROVAL_STATUS, BANK_STATUS} from '@/assets/js/status.js'
import {isEqual, cloneDeep} from 'lodash'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import moment from 'moment'
import {SST_OPTIONS} from '@/assets/js/options.js'

export default {
    props:{
        show_add_bank: Boolean,
        product: Object,
        status: Array,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            show_agreement_percent: false,
            form:{
                bank_code: '',
                bank_name: '',
                banker_id: '',
                interest: '',
                tenure_years: '',
                bank_status: '',
                loan_amount:'',
                installment:'',
                arrangement_fee: 0,
                arrangement_fee_any_amount: 0,
                arrangement_fee_amount: 0,
                arrangement_fee_sst: 0,
                prod_bnk_submission_date: null,
                approved_date: null,
                arrangement_fee_percent: null,
                prod_bnk_approved_loan_amount: '',
                prod_bnk_add_cost: '',
            },
            banks:[],
            dsr_bank: null,
            bankers: [],
            is_loading_btn: false,
            is_loading_bank: false,
            bank_status_options: BANK_STATUS,
            update_status_role_ids: [1],
            FeeOptions: [
                { text: '0%', value: '0.00' },
                { text: '2%', value: '2.00' },
                { text: '3%', value: '3.00'},
                { text: '5%', value: '5.00' },
                { text: 'Specify', value: 'Specify' }
            ],
            SST_OPTIONS: SST_OPTIONS,
            next_status: {
                main: null,
                sub: null
            },
        }
    },
		created() {
      this.getBankerListHandler(null);
    },
    computed: {
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useAccessControlStore, ['userBankerList', 'userLoanOfficerList']),
        show: {
            get() {
                return this.show_add_bank
            },
            set(newVal) {
                this.$emit('update:show_add_bank', newVal)
            },
        },
        isApprovedBank(){
            return BANK_APPROVAL_STATUS.indexOf(this.form.bank_status) !== -1;
        }
    },
    watch:{
        product:{
            async handler(newVal, oldVal){
                this.getBanks()
                this.setProductDetail(newVal)
            },
            immediate: true,
        },
        'form':{
            handler(newVal){
                this.form.installment = calculatePersonalLoanInstallment(newVal.loan_amount, newVal.interest, newVal.tenure_years)

                let sst_fee = parseFloat(newVal.arrangement_fee) * parseFloat(newVal.arrangement_fee_sst) / 100

                if(newVal.arrangement_fee_percent !== null){
                    this.form.arrangement_fee = parseFloat(parseFloat(newVal.loan_amount) * parseFloat(newVal.arrangement_fee_percent) / 100).toFixed(2)
                }

                //set total arragement fee
                let arrangement_fee_amount = parseFloat(newVal.arrangement_fee) + parseFloat(sst_fee)
                if(isNaN(arrangement_fee_amount)){
                    this.form.arrangement_fee_amount = 0
                }else{
                    this.form.arrangement_fee_amount = parseFloat(arrangement_fee_amount).toFixed(2)
                }
            },
            deep: true
        },
        'form.bank_code':{
            handler(newVal){
                this.setBankRate()
            },
        },
    },
    methods:{
        ...mapActions(useProductStore, ['getCustomerProducts','getBankersBasedOnBank','sendEmailToBanker']),
        setBankRate(){
            let dsr_bank = this.banks.find(bank => bank.bank_code == this.form.bank_code)
            if(dsr_bank){
                this.form.interest = dsr_bank.bank_loan_interest_rate
                this.form.tenure_years = dsr_bank.bank_loan_tenure_year
                this.dsr_bank = dsr_bank
                this.form.bank_name = dsr_bank.bank_name
            }else{
                this.form.interest = ''
                this.form.tenure_years = ''
            }
        },
        async setProductDetail(data){
            // this.form.arrangement_fee_amount = data.product_detail.prod_pl_loan_agreement_fees
            // this.form.arrangement_fee = data.product_detail.prod_pl_loan_agreement_rate
            // this.form.arrangement_fee_sst = data.product_detail.prod_pl_loan_agreement_rate_sst
            this.form.prod_loan_officer_id = data.prod_loan_officer_id
        },
        async getBanks(){
            this.is_loading_bank = true
            axios.get(services.customer + 'customer/' + this.product.prod_customer_id +'/dsr.eligibilities?formula=PL', {headers: getHeader()})
            .then(res=>{
                    this.banks = res.data.data.bank_eligibilities
                    this.is_loading_bank = false
                })
                .catch(e =>{
                    this.errorFunction(e)
                })
        },
				async getBankerListHandler(bank_code){
            this.is_loading_bank = true
						try{
								this.bankers = cloneDeep(this.userBankerList);
								this.bankers = await this.getBankersBasedOnBank(cloneDeep(this.userBankerList), bank_code, this.product.prod_type);
								let banker = this.bankers.find(bBank => bBank.id == this.form.banker_id)
                if(!banker){
                    this.form.banker_id = null
                }
								let selected_bank = this.banks.find(bank => bank.bank_code == bank_code)
								if(!_gHlp.isEmpty(selected_bank)){
                    this.form.bank_name = selected_bank.bank_name
                }

								this.is_loading_bank = false
            }catch(e){
								this.is_loading_bank = false
                _gNotif.errorFunction(e)
            }
        },
        determinePersonalLoanCaseStatus(current_status){
            const currentStatus = this.status.find((item) => item.status === current_status.status)

            this.next_status.main = currentStatus.parent.status
            this.next_status.sub = currentStatus.status

            // if have multiple submission, loop through all banks and find which order is higher 
            if(this.product.product_banks.length > 0){
                const product_banks = this.product.product_banks
                product_banks.forEach(product_bank => {
                    const product_bank_status = this.status.find((item) => item.status === product_bank.prod_bnk_stage_status)
                    if(product_bank_status){
                        if(product_bank_status.parent.order > currentStatus.parent.order){
                            this.next_status.main = product_bank_status.parent.status
                            this.next_status.sub = product_bank_status.status
                        }
                    }
                });
            }
        },
        editProductDetail(bank){
            const status = this.status.find((item) => item.status === this.form.bank_status)

            if(!status || !status.parent){
                this.errorFunction(null, 'Status could not be found.')
                return
            }
            
            let data = {
                "prod_agent_id": this.product.prod_agent_id,
                "prod_agent_username" : this.product.prod_agent_username,
                "prod_customer_basket" : this.product.prod_customer_basket,
                "prod_customer_id" : this.product.prod_customer_id,
                "prod_customer_name" : this.product.prod_customer_name,
                "prod_type": this.product.prod_type,
                "prod_main_status": this.next_status.main,
                "prod_status": this.next_status.sub,
                "product_detail" : {
                    "prod_pl_stage_status": this.next_status.sub,
                    "prod_pl_loan_amount":this.form.loan_amount,
                    "prod_pl_interest":this.form.interest,
                    "prod_pl_tenure":this.form.tenure_years,
                    "prod_pl_installment":this.form.installment,
                    // "prod_pl_loan_agreement_fees": this.form.arrangement_fee_amount,
                    // "prod_pl_loan_agreement_rate": this.form.arrangement_fee,
                    // "prod_pl_loan_agreement_rate_sst": this.form.arrangement_fee_sst
                },
            }
            axios.post(services.product + 'product/' + this.product.prod_id, data, {headers: getHeader()})
                .then(res=>{
										this.sendEmailToBanker(bank,res.data)
                    this.resetField()
                    this.is_loading_btn = false
                    this.$emit('update:show_add_bank', false)
                    caseEventBus.$emit('refresh-cases')
                    this.notifySuccess('<b>Bank</b> - Successfully Added.')
                })
                .catch(e=>{
                    this.is_loading_btn = false
                    this.errorFunction(e)
                })
        },
        addBank(){
            //check if bank empty
            if(!this.form.bank_code){
                this.errorFunction(null, 'Please select a bank.')
                return  
            }

            // check if status empty
            if(!this.form.bank_status){
                this.errorFunction(null, 'Please select the bank status.')
                return  
            }

            const status = this.status.find((item) => item.status === this.form.bank_status)

            if(!status || !status.parent){
                this.errorFunction(null, 'Status could not be found.')
                return
            }

            this.determinePersonalLoanCaseStatus(status)

            let data = {
                "prod_bnk_name": this.form.bank_name,
                "prod_bnk_prod_id": this.product.prod_id,
                "prod_bnk_logo_url": this.dsr_bank ? this.dsr_bank.bank_image_url : null,
                "prod_bnk_banker_id": this.form.banker_id ?? null,
                "prod_bnk_stage_status": status.status,
                "prod_bnk_loan_amount": this.form.loan_amount,
                "prod_bnk_spa_amount": null,
                "prod_bnk_interest": this.form.interest,
                "prod_bnk_margin": null,
                "prod_bnk_tenure": this.form.tenure_years,
                "prod_bnk_gross_cashback": null,
                "prod_bnk_installment": this.form.installment,
                "prod_bnk_code": this.form.bank_code,
                "prod_bnk_submission_date": this.form.prod_bnk_submission_date,
                "prod_bnk_lo_sign_date": null,
                "prod_bnk_approved_date": this.form.approved_date,
                "prod_bnk_approved_loan_amount": this.form.prod_bnk_approved_loan_amount,
                "prod_bnk_add_cost": this.form.prod_bnk_add_cost,
                "prod_bnk_agreement_rate": this.form.arrangement_fee,
                "prod_bnk_agreement_rate_sst": this.form.arrangement_fee_sst,
                "prod_bnk_agreement_fees": this.form.arrangement_fee_amount,
            }

            this.is_loading_btn = true
            axios.post(services.product + 'product-bank', data, {headers: getHeader()})
                .then(res=>{
                    this.editProductDetail(res.data)
                })
                .catch(e =>{
                    this.errorFunction(e)
                })
        },
        resetField(){
            this.dsr_bank = null
            this.form.bank_code = '',
            this.form.bank_name = '',
            this.form.banker_id = '',
            this.form.interest = '',
            this.form.tenure_years = '',
            this.form.bank_status = '',
            this.form.loan_amount ='',
            this.form.installment ='',
            this.form.arrangement_fee = 0,
            this.form.arrangement_fee_any_amount = 0,
            this.form.arrangement_fee_amount = 0,
            this.form.arrangement_fee_sst = 0,
            this.form.prod_bnk_submission_date = null,
            this.form.approved_date = null,
            this.form.arrangement_fee_percent = null,
            this.form.prod_bnk_approved_loan_amount = ''
            this.form.prod_bnk_add_cost = ''
        }
    }
}
</script>